<template>
  <a-modal
    title="修改状态"
    :visible="modalVisible"
    @ok="handleConfirm"
    @cancel="handleCancel"
    @update:visible="(val) => { modalVisible = val }"
    :maskClosable="false"
  >
    <a-form-item label="当前状态">
      <a-select
        v-model:value="selectedStatus"
        placeholder="请选择状态"
        style="width: 100%"
        class="status-select"
      >
        <a-select-option
          v-for="(d, index) in statusOptions"
          :key="index"
          :value="d.value || d.dictValue"
        >
          {{ d.label || d.dictLabel }}
        </a-select-option>
      </a-select>
    </a-form-item>
  </a-modal>
</template>

<script setup>
import { ref, watch } from 'vue'
import { message } from 'ant-design-vue'

defineOptions({
  name: 'EditStatusModal',
})

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  statusOptions: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['confirm', 'cancel', 'update:visible'])

const selectedStatus = ref(undefined)
const modalVisible = ref(false)

watch(
  () => props.visible,
  (newVal) => {
    modalVisible.value = newVal
    if (newVal) {
      selectedStatus.value = undefined
    }
  },
  { immediate: true }
)

watch(modalVisible, (newVal) => {
  if (!newVal) {
    emit('update:visible', false)
    emit('cancel')
  }
})

/** 确认 */
const handleConfirm = () => {
  if (!selectedStatus.value) {
    message.warning('请选择状态', 3)
    return
  }
  emit('confirm', selectedStatus.value)
}

/** 取消 */
const handleCancel = () => {
  selectedStatus.value = undefined
  emit('cancel')
}
</script>

<style scoped>
/* 输入框圆角样式 */
.status-select :deep(.ant-select-selector) {
  border-radius: 4px !important;
}
</style>

<style>
/* Modal 按钮样式 - 全局样式确保生效（Modal是动态创建的） */
.ant-modal-footer .ant-btn {
  border-radius: 4px !important;
}

.ant-modal-footer .ant-btn-primary {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.ant-modal-footer .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.ant-modal-footer .ant-btn-default {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.ant-modal-footer .ant-btn-default:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}
</style>
